import React from 'react'
import { Card, Flex, Text } from '@tremor/react'
import { Target, Phone, Star, Clock, Flame } from '@/components/icons'
import { cn } from '@/lib/utils'

const goals = [
  {
    icon: Target,
    text: '55% team conversion target',
    highlight: true,
    color: 'text-violet-500',
    bgColor: 'bg-violet-100',
  },
  {
    icon: Phone,
    text: 'Keep missed calls <15/month',
    color: 'text-red-500',
    bgColor: 'bg-red-100',
  },
  {
    icon: Star,
    text: 'Quality score 80+',
    color: 'text-amber-500',
    bgColor: 'bg-amber-100',
  },
  {
    icon: Clock,
    text: 'Peak hours: 10 AM - 2 PM',
    color: 'text-blue-500',
    bgColor: 'bg-blue-100',
  },
]

export function TeamFocusV2() {
  return (
    <Card className="shadow-md hover:shadow-lg transition-shadow duration-200 border-l-4 border-l-amber-500 bg-gradient-to-br from-amber-50/50 via-white to-white border-t border-r border-b border-amber-100 animate-fade-in">
      {/* Header */}
      <Flex alignItems="center" className="gap-3 mb-4">
        <div className="p-2 rounded-lg bg-amber-100 text-amber-600">
          <Target className="w-5 h-5" />
        </div>
        <Text className="text-zinc-900 font-semibold text-lg">
          Team Focus Today
        </Text>
      </Flex>

      {/* Goals Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {goals.map((goal, index) => {
          const Icon = goal.icon
          return (
            <div
              key={index}
              className={cn(
                "flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200",
                goal.highlight
                  ? "bg-violet-50 ring-1 ring-violet-200 hover:ring-violet-300"
                  : "bg-white border border-zinc-100 hover:border-zinc-200 hover:shadow-sm"
              )}
            >
              <div className={cn(
                "p-1.5 rounded-md",
                goal.bgColor
              )}>
                <Icon className={cn("w-4 h-4", goal.color)} />
              </div>
              <span className={cn(
                "text-sm",
                goal.highlight ? "font-medium text-zinc-900" : "text-zinc-700"
              )}>
                {goal.text}
              </span>
            </div>
          )
        })}
      </div>

      {/* Motivational Banner - LIGHT VERSION */}
      <div className="mt-4 p-4 bg-gradient-to-r from-amber-100 to-amber-50 border border-amber-200 rounded-lg">
        <Flex alignItems="center" justifyContent="center" className="gap-2">
          <Flame className="w-5 h-5 text-amber-600" />
          <span className="text-amber-700 font-bold uppercase tracking-wide text-sm">
            CONSISTENT QUALITY = MAX EARNINGS
          </span>
          <Flame className="w-5 h-5 text-amber-600" />
        </Flex>
      </div>
    </Card>
  )
}
